// extracted by mini-css-extract-plugin
module.exports = {"title":"RulesItem_title__Bjt6b","content":"RulesItem_content__UsQqy"};